import { useMediaQuery } from "react-responsive";

export const useMediaQueryCustom = () => {

    const isMobile480 = useMediaQuery({ maxWidth: 480 })
    const isTablet768 = useMediaQuery({ minWidth: 480, maxWidth: 768 })
    const isTablet1024 = useMediaQuery({ minWidth: 768, maxWidth: 1024 })
    const isLaptopDesktop = useMediaQuery({ minWidth: 1024 })

    return { isMobile480, isTablet768, isTablet1024, isLaptopDesktop };
}
